// bao migrate skip
import "./../../bindings/bao-tabs";
import "./../../bindings/bao-number-box";
import "./../../factories/translate-dialog";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialog from "./../../factories/bao-dialog";
import TabPage from "./../../factories/tab-page";
import SearchPaging2 from "./../../factories/search-paging2";
import TranslateDialogViewModel from "./../../factories/translate-dialog";
class OrgUnitViewModel extends SearchPaging2 {
    constructor(tabPage, menu) {
        super(tabPage);
    }
    InfoLevelId = ko.observable();
    InfoLevelName = ko.observable();
    SortLevel: KnockoutObservable<string>;
    CompleteCheck() {
        let isComplete = true;
        if (Bao.Utils.String.IsNullOrEmpty(this.OrgUnitName())) {
            isComplete = false;
        }
        if (Bao.Utils.String.IsNullOrEmpty(this.OrgUnitDescription())) {
            isComplete = false;
        }
        if (Bao.Utils.String.IsNullOrEmpty(this.SortLevel())) {
            isComplete = false;
        }
        if (!isComplete) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    }
    ;
    OrgUnitName: KnockoutComputed<any> = ko.pureComputed({
        read: () => {
            switch (Bao.Session.Language.LanguageIndex()) {
                case 1:
                    return this.OrgUnitName1();
                case 2:
                    return this.OrgUnitName2();
                case 3:
                    return this.OrgUnitName3();
                case 4:
                    return this.OrgUnitName4();
                case 5:
                    return this.OrgUnitName5();
            }
        },
        write: (value) => {
            switch (Bao.Session.Language.LanguageIndex()) {
                case 1:
                    this.OrgUnitName1(value);
                    break;
                case 2:
                    this.OrgUnitName2(value);
                    break;
                case 3:
                    this.OrgUnitName3(value);
                    break;
                case 4:
                    this.OrgUnitName4(value);
                    break;
                case 5:
                    this.OrgUnitName5(value);
                    break;
            }
        }
    });
    OrgUnitName1 = ko.observable<string>();
    OrgUnitName2 = ko.observable<string>();
    OrgUnitName3 = ko.observable<string>();
    OrgUnitName4 = ko.observable<string>();
    OrgUnitName5 = ko.observable<string>();
    TranslateName() {
        let translateDialog = new TranslateDialogViewModel(this.OrgUnitName1, this.OrgUnitName2, this.OrgUnitName3, this.OrgUnitName4, this.OrgUnitName5);
        translateDialog.Open().then(() => {
        });
    }
    ;
    OrgUnitDescription: KnockoutComputed<any> = ko.pureComputed({
        read: () => {
            switch (Bao.Session.Language.LanguageIndex()) {
                case 1:
                    return this.OrgUnitDescription1();
                case 2:
                    return this.OrgUnitDescription2();
                case 3:
                    return this.OrgUnitDescription3();
                case 4:
                    return this.OrgUnitDescription4();
                case 5:
                    return this.OrgUnitDescription5();
            }
        },
        write: (value) => {
            switch (Bao.Session.Language.LanguageIndex()) {
                case 1:
                    this.OrgUnitDescription1(value);
                    break;
                case 2:
                    this.OrgUnitDescription2(value);
                    break;
                case 3:
                    this.OrgUnitDescription3(value);
                    break;
                case 4:
                    this.OrgUnitDescription4(value);
                    break;
                case 5:
                    this.OrgUnitDescription5(value);
                    break;
            }
        }
    });
    OrgUnitDescription1 = ko.observable<string>();
    OrgUnitDescription2 = ko.observable<string>();
    OrgUnitDescription3 = ko.observable<string>();
    OrgUnitDescription4 = ko.observable<string>();
    OrgUnitDescription5 = ko.observable<string>();
    Categories = ko.observableArray();
    TranslateDescription() {
        let translateDialog = new TranslateDialogViewModel(this.OrgUnitDescription1, this.OrgUnitDescription2, this.OrgUnitDescription3, this.OrgUnitDescription4, this.OrgUnitDescription5);
        translateDialog.Open().then(() => {
        });
    }
    InitUrl() {
        return "MasterData/OrgUnit/Init";
    }
    init() {
        return super.init()
            .then(() => {
            return Bao.post("MasterData/OrgUnit/GetCategories");
        })
            .then((categories) => {
            this.Categories(categories);
        })
            .then(() => { return this.InitTabController(); })
            .then(() => {
            let TagTab = new TabPage(null);
            TagTab.Url("MasterData/OrgUnitTagTab");
            TagTab.AutoSelect = true;
            TagTab.IsClosable(false);
            TagTab.PreLoad(true);
            TagTab.Visible(true);
            this.TabController.AddTab(TagTab);
            // vorerst nicht anzeigen!
            let newTabFolderStructureChecklist = new TabPage(null);
            newTabFolderStructureChecklist.Url("MasterData/OrgUnitFolderStructureChecklistTab");
            newTabFolderStructureChecklist.AutoSelect = false;
            newTabFolderStructureChecklist.IsClosable(false);
            newTabFolderStructureChecklist.PreLoad(true);
            newTabFolderStructureChecklist.Visible(true);
            this.TabController.AddTab(newTabFolderStructureChecklist);
        });
    }
}
export default OrgUnitViewModel;